import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: inline-block;
  width: 14px;
  height: 15px;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  svg {
    width: 14px;
    height: 15px;
  }
`;
